import { useState } from "react";
import { useForm } from "react-hook-form";
import { formatDateT } from "../../../../shared/utils/formatters";
import NewDateTimePicker from "../../../../shared/components/newDateTimePicker";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import useQuoteStore from "../../../quote/store/QuoteStore";
import ModalWrapper from "../../../../shared/components/ModalWrapper";
import Button from "../../../../shared/components/Button";

const PolicyDateTimeModal = ({ actions, onClose }) => {
  const {
    watch,
    setValue,
    control,
    handleSubmit,
    formState: { errors, isValid },
    trigger,
  } = useForm();
  const STATE = useAppStateStore();

  const [isEditMode, setIsEditMode] = useState(false);
  const customerQuotes = STATE.customerQuotes;

  const handleYesClick = async () => {
    actions();
    onClose();
  };

  const handleConfirmClick = () => {
    const { updateField } = useQuoteStore.getState();
    const newDate = formatDateT(watch("date"));
    updateField("risk.startDate", newDate);
    actions();
    onClose();
  };

  return (
    <ModalWrapper heading="Confirm Start Date" onClose={onClose}>
      <form onSubmit={handleSubmit(handleConfirmClick)}>
        {!isEditMode ? (
          <>
            <div className="tw-flex tw-flex-col tw-gap-2">
              <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-dis-border-strong tw-bg-dis-info-panel tw-px-4 tw-py-3">
                <span className="tw-text-base tw-font-bold tw-text-dis-navy">
                  Cover start date
                </span>
                <span className="tw-text-base tw-text-dis-text-2">
                  {customerQuotes?.startDate
                    ?.split("T")[0]
                    .split("-")
                    .reverse()
                    .join("/")}
                </span>
              </div>
              <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-dis-border-strong tw-bg-dis-info-panel tw-px-4 tw-py-3">
                <span className="tw-text-base tw-font-bold tw-text-dis-navy">
                  Cover start time
                </span>
                <span className="tw-text-base tw-text-dis-text-2">
                  {customerQuotes?.startDate?.split("T")[1]}
                </span>
              </div>
            </div>
            <div className="tw-mb-3 tw-mt-5 tw-rounded-xl tw-bg-dis-sky-tint tw-px-4 tw-py-2.5 tw-text-sm tw-leading-[1.45] tw-text-dis-navy">
              Cover start date and time cannot be in the past.
            </div>
            <p className="tw-mb-3 tw-text-base tw-leading-[1.5] tw-text-dis-text-2">
              Are you sure you would like your policy to start at the date and
              time shown above?
            </p>
            <div className="tw-flex tw-justify-end tw-gap-3 max-[480px]:tw-flex-col">
              <Button
                type="button"
                variant="soft"
                size="small"
                onClick={() => setIsEditMode(true)}
                className="max-[480px]:tw-w-full"
              >
                Edit
              </Button>
              <Button
                type="button"
                variant="main"
                size="small"
                onClick={handleYesClick}
                disabled
                className="max-[480px]:tw-w-full"
              >
                Yes
              </Button>
            </div>
          </>
        ) : (
          <>
            <div>
              <NewDateTimePicker
                name="date"
                label="When would you like your cover to start?"
                errors={errors.date}
                setValue={setValue}
                control={control}
                rules={{
                  required: "Date is required",
                }}
                watch={watch}
                trigger={trigger}
                defaultValue={watch("date")}
                minDate={new Date()}
                maxDate={
                  new Date(new Date().setDate(new Date().getDate() + 29))
                }
              />
              <div className="tw-mb-5 tw-mt-3 tw-rounded-xl tw-bg-dis-sky-tint tw-px-4 tw-py-2.5 tw-text-sm tw-leading-[1.45] tw-text-dis-navy">
                A change in cover start date may result in a change in price.
              </div>
              <div className="tw-flex tw-justify-end tw-gap-3 max-[480px]:tw-flex-col">
                <Button
                  type="button"
                  variant="soft"
                  size="small"
                  onClick={() => setIsEditMode(false)}
                  className="max-[480px]:tw-w-full"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="main"
                  size="small"
                  disabled={!isValid}
                  className="max-[480px]:tw-w-full"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </>
        )}
      </form>
    </ModalWrapper>
  );
};

export default PolicyDateTimeModal;
